import { opaccAjaxPlugin } from '../opacc.static.js';

/** @module article */

/**
 * Preisanzeige aktualisieren
 */
export class OpaccPrice {
	constructor() {
		this.wrapperElement = document.querySelector('.content');
		this.priceSelector = '.opc-price';
		this.jsonToPost = { items: [] };

		this.checkLoadingTypeAndGetPrice();
		this.attachEventListener();
	}

	/**
	 * Event Registrierungen im DOM
	 *
	 */
	attachEventListener() {
		this.wrapperElement.addEventListener('change', (e) => {
			if (e.target === this.wrapperElement) {
				this.checkLoadingTypeAndGetPrice();
			}
		});
	}

	/**
	 *
	 *
	 */
	getAsynPrice() {
		let data = { type: 'price', catitems: JSON.stringify(this.jsonToPost) };
		let url = opaccAjaxPlugin.setAsyncUrl(true);
		opaccAjaxPlugin.fetchAsynPostForm(url, data, this.getPriceFromJsonResult.bind(this), this.getDefaultErrorFnc, true);
		this.jsonToPost = { items: [] };
	}

	/**
	 *
	 *
	 * @param {*} response
	 */
	getPriceFromJsonResult(response) {
		if (response.success) {
			response.dataAsJson.items.forEach( val => {
				//CatItem.BoId oder CatItem.ArtInternalNo
				// eslint-disable-next-line no-unused-vars
				let htmlItemId = 'data-op-catitemartinternalno';
				let jsonItemId = 'catitemartinternalno';
				if (val.catitemboid) {
					htmlItemId = 'data-op-catitemboid';
					jsonItemId = 'catitemboid';
				}

				let itemSelector = '.opc-price.async:not(.has-loaded)';
				let htmlElem = this.wrapperElement.querySelector(`${itemSelector}[data-op-catitemboid='${val[jsonItemId]}']`) || undefined;

				if (!!htmlElem) {
					let discountObj = htmlElem.querySelector('span.value') || undefined;
					if (+val.loadingtype === 1 || +val.loadingtype === 2) {

						let tmpHtmlObj = document.createElement('div');
						tmpHtmlObj.innerHTML = val.html;

						let tmpCurrentHtmlObj = htmlElem.cloneNode(true);

						let sortedArray = [];

						let jBasePrice = tmpHtmlObj.querySelector('.price-basis') || undefined;
						let jServicePrice = tmpHtmlObj.querySelector('.price-service') || undefined;
						let jPromoPrice = tmpHtmlObj.querySelector('.price-promotion') || undefined;

						let htmlLabel = tmpCurrentHtmlObj.querySelector('.price-label') || undefined;
						let htmlBasePrice = tmpCurrentHtmlObj.querySelector('.price-basis') || undefined;
						let htmlServicePrice = tmpCurrentHtmlObj.querySelector('.price-service') || undefined;
						let htmlPromoPrice = tmpCurrentHtmlObj.querySelector('.price-promotion') || undefined;
						let htmlInfo = tmpCurrentHtmlObj.querySelector('.price-info') || undefined;

						let sortInfo = tmpCurrentHtmlObj.dataset.opSort.split('-');
						sortInfo.forEach((sortVal) => {
							switch (sortVal) {
							case 'b':
								(!!jBasePrice) ? sortedArray.push(jBasePrice) : (!!htmlBasePrice) ? sortedArray.push(htmlBasePrice) : '';
								break;
							case 's':
								(!!jServicePrice) ? sortedArray.push(jServicePrice) : (!!htmlServicePrice) ? sortedArray.push(htmlServicePrice) : '';
								break;
							case 'p':
								(!!jPromoPrice) ? sortedArray.push(jPromoPrice) : (!!htmlPromoPrice) ? sortedArray.push(htmlPromoPrice) : '';
								break;
							}
						});

						//Label zuerst einfuegen
						(!!htmlLabel) ? sortedArray.unshift(htmlLabel) : '';
						//Info am Schluss einfuegen
						(!!htmlInfo) ? sortedArray.push(htmlInfo) : '';

						// replace Price-Element
						htmlElem.innerHTML = '';
						sortedArray.forEach(item => {
							htmlElem.append(item);
						});

					} else {
						// if discountObj --> overwrite
						if (!!discountObj) {
							// overwrite just the value
							if (val.isdiscount) {
								discountObj.replaceWith(val.html);
								// Wenn kein Discount existiert wird dieser geschrieben
							} else {
								// Totales HTML vom JSON Resultat an entsprechender Stelle einfuegen
								if (val.html) { htmlElem.innerHTML = val.html; }
							}
						} else {
							// Totales HTML vom JSON Resultat an entsprechender Stelle einfuegen
							if (val.html) { htmlElem.innerHTML = val.html; }
						}
					}

					// Basispreisabhaengige CSS-Klassen setzen
					if (val.basispriceisset || val.promopriceisset || val.servicepriceisset) {
						let styleClassArray = [];
						styleClassArray.push('has-loaded');
						val.basispriceisset ? styleClassArray.push('is-basis') : '';
						val.promopriceisset ? styleClassArray.push('is-promo') : '';
						val.servicepriceisset ? styleClassArray.push('is-service') : '';

						styleClassArray.forEach(item => {
							htmlElem.classList.add(item);
						});
					}
				}
			});
		}
	}

	/**
	 *
	 *
	 */
	checkLoadingTypeAndGetPrice() {
		let priceElem = this.wrapperElement.querySelector(this.priceSelector);
		let source = null;
		let loadingType = null;
		if (priceElem) {
			source = +priceElem.dataset.opSource;
			loadingType = +priceElem.dataset.opLoadingtype;
		}
		let async = (source !== 2 && source !== 3 && loadingType !== 3) ? '' : 'async';

		if (async === 'async') {
			let items = this.wrapperElement.querySelectorAll(this.priceSelector);
			Array.from(items).forEach((value) => {
				let item = {};
				if (value.dataset.opSource) { item.source = value.dataset.opSource; }
				if (value.dataset.opService) { item.service = value.dataset.opService; }
				if (value.dataset.opLoadingtype) { item.loadingtype = value.dataset.opLoadingtype; }
				if (value.dataset.opCatitemboid) { item.catitemboid = value.dataset.opCatitemboid; }
				if (value.dataset.opCatitemartinternalno) { item.catitemartinternalno = value.dataset.opCatitemartinternalno; }
				if (value.dataset.opLabel) { item.optionlabeltext = value.dataset.opLabel; }
				if (value.dataset.opInfo) { item.optioninfotext = value.dataset.opInfo; }
				if (value.dataset.opSignisset) { item.signisset = value.dataset.opSignisset; }
				if (value.dataset.opConditionaddress) { item.conditionaddress = value.dataset.opConditionaddress; }
				if (value.dataset.opSort) { item.sort = value.dataset.opSort; }
				if (value.dataset.opXfas) { item.xfas = value.dataset.opXfas; }
				if (value.dataset.opCatitemboid) {
					item.key = value.classList.contains('discount') ? `${value.dataset.opCatitemboid}-discount` : `${value.dataset.opCatitemboid}-price`;
				}
				if (value.dataset.opAsynctemplate) item.template = value.dataset.opAsynctemplate;

				if (value.classList.contains('discount')) { item.isdiscount = true; }
				this.jsonToPost.items.push(item);
			});

			// Unterschied ob Binding automatisch oder interaktiv passiert
			switch (loadingType) {
			case 2:
				priceElem.addEventListener('mouseover', () => {
					this.getAsynPrice();
				});
				break;
			default:
				this.getAsynPrice();
				break;
			}
		}
	}
}